module.exports = __webpack_public_path__ + "static/bg-box2-phone-d56aa6032bb37f02f57b7ef4475ef7b4.png";